const restoreListeners = new Set<() => void>();

/** Restore a minimized floating equipment panel without remounting the canvas. */
export function requestRestoreFloatingEquipmentPanel() {
  restoreListeners.forEach((fn) => fn());
}

export function subscribeRestoreFloatingEquipmentPanel(fn: () => void) {
  restoreListeners.add(fn);
  return () => {
    restoreListeners.delete(fn);
  };
}
